import React from 'react'
import {Icon} from '@chakra-ui/react'

const CreditCardIcon = (props) => {
    return (
        <Icon viewBox="0 0 50 48" {...props}>
            <path
                d="M6.73998 24.3856C6.73998 24.9269 7.17881 25.3657 7.72014 25.3657H15.4527C15.994 25.3657 16.4328 24.9269 16.4328 24.3856C16.4328 23.8442 15.994 23.4054 15.4527 23.4054H7.72014C7.17881 23.4054 6.73998 23.8442 6.73998 24.3856Z"
                fill="currentColor"
            />
            <path
                d="M22.1 28.4786C22.1 29.0199 22.5388 29.4588 23.0801 29.4588H26.9201C27.4615 29.4588 27.9003 29.0199 27.9003 28.4786C27.9003 27.9373 27.4615 27.4985 26.9201 27.4985H23.0801C22.5388 27.4985 22.1 27.9373 22.1 28.4786Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.6491 35.52C31.6491 36.0895 32.1107 36.5511 32.6801 36.5511H44.2001C44.7696 36.5511 45.2312 36.0895 45.2312 35.52V27.84C45.2312 27.2706 44.7696 26.809 44.2001 26.809H32.6801C32.1107 26.809 31.6491 27.2706 31.6491 27.84V35.52ZM43.1691 34.489H33.7112V28.8711H43.1691V34.489Z"
                fill="currentColor"
            />
            <path
                d="M19.2401 25.3657C18.6988 25.3657 18.26 24.9269 18.26 24.3856C18.26 23.8442 18.6988 23.4054 19.2401 23.4054H26.9201C27.4615 23.4054 27.9003 23.8442 27.9003 24.3856C27.9003 24.9269 27.4615 25.3657 26.9201 25.3657H19.2401Z"
                fill="currentColor"
            />
            <path
                d="M7.72014 29.4588C7.17881 29.4588 6.73998 29.0199 6.73998 28.4786C6.73998 27.9373 7.17881 27.4985 7.72014 27.4985H19.2401C19.7815 27.4985 20.2203 27.9373 20.2203 28.4786C20.2203 29.0199 19.7815 29.4588 19.2401 29.4588H7.72014Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M49.0406 37.4604C49.0406 39.5857 47.3057 41.3205 45.1804 41.3205H4.8604C2.73507 41.3205 1.00024 39.5857 1.00024 37.4604V19.9113C0.986957 19.847 0.97998 19.7803 0.97998 19.7121C0.97998 19.6438 0.986957 19.5772 1.00024 19.5129V13.1913C0.986957 13.127 0.97998 13.0603 0.97998 12.9921C0.97998 12.9238 0.986957 12.8572 1.00024 12.7929V10.5804C1.00024 8.45505 2.73507 6.72021 4.8604 6.72021H45.1804C47.3057 6.72021 49.0406 8.45505 49.0406 10.5804V37.4604ZM2.96056 20.6922V37.4604C2.96056 38.503 3.81772 39.3602 4.8604 39.3602H45.1804C46.2231 39.3602 47.0802 38.503 47.0802 37.4604V20.6922H2.96056ZM47.0802 18.7319H2.96056V13.9722H47.0802V18.7319ZM47.0802 12.0119H2.96056V10.5804C2.96056 9.5377 3.81772 8.68053 4.8604 8.68053H45.1804C46.2231 8.68053 47.0802 9.5377 47.0802 10.5804V12.0119Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CreditCardIcon
